import { GridContainer, GridItem, InformationField } from '../../../components/shared';
import useStyles from '../style';
import { useEffect, useState } from 'react';
import { INDEPENDENT_REP_OF_SUBLOCATION } from '../../../constants/CommonConstants';
import { Box, Button } from '@mui/material';
import { useHasRoles } from '../../../hooks';
import { ROLE } from '../../../constants/roles';
import Modal from '../../../components/shared/Modal';
import IndependantRepHistoryModal from '../../ManageIndepenantRep/IndependantRepHistoryModal';
import { getDateFormat } from '../../../utils/common-methods'; // Adjust the path as needed

const IndependentRepUserDetails = ({ sublocation, showCustArCode = false }) => {
  const classes = useStyles();
  const [payCode, setPayCode] = useState('');
  const [effectFromDate, setEffectFromDate] = useState('');
  const [effectTODate, setEffectTODate] = useState('');
  const [independentRep, setIndependentRep] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [arCode, setArCode] = useState('');
  const [custArCode, setCustArCode] = useState('');
  const isRole = useHasRoles([
    ROLE.SUPER_ADMIN_IT,
    ROLE.ACCOUNTING,
    ROLE.EXECS,
    ROLE.MANAGER,
    ROLE.DM,
    ROLE.REGIONAL_MANAGER,
    ROLE.VP,
  ]);

  useEffect(() => {
    setPayCode(sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.PAY_CODE}_${sublocation?.id}`] || 'N/A');
    setIndependentRep(sublocation?.independentRep || 'N/A');
    setEffectFromDate(
      getDateFormat(sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.EFFECT_FROM}_${sublocation?.id}`] || 'N/A'),
    );
    setEffectTODate(
      getDateFormat(sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.EFFECT_TO}_${sublocation?.id}`] || 'N/A'),
    );
    setArCode(sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.AR_CODE}_${sublocation?.id}`] || 'N/A');
    const x3LocationId = sublocation?.location?.X3_LocationsID;
    setCustArCode(x3LocationId ? `VP-${x3LocationId}` : 'N/A');
  }, []);

  const closeModal = () => {
    setModalOpen(false);
  };

  const independentRepValue =
    Array.isArray(independentRep) && independentRep.length > 0
      ? independentRep.map((rep) => rep.fullName || `${rep.firstName} ${rep.lastName}`).join(', ')
      : 'N/A';
  const feeValue = sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.FEE}_${sublocation?.id}`]
    ? '$' + parseFloat(sublocation[`${INDEPENDENT_REP_OF_SUBLOCATION.FEE}_${sublocation?.id}`]).toFixed(2)
    : 'N/A';
  const rateValue = sublocation?.[`${INDEPENDENT_REP_OF_SUBLOCATION.RATE}_${sublocation?.id}`]
    ? `${(sublocation[`${INDEPENDENT_REP_OF_SUBLOCATION.RATE}_${sublocation?.id}`] * 100).toFixed(0)}%`
    : 'N/A';
  const detailRows = [
    { label: 'Effect From', value: effectFromDate },
    { label: 'Effect To', value: effectTODate },
    { label: 'Independent Rep', value: independentRepValue },
    { label: 'Rate Type', value: payCode || 'N/A' },
    { label: 'Fee', value: feeValue },
    { label: 'Rate', value: rateValue },
    { label: 'AR Code', value: arCode },
  ];

  if (showCustArCode) {
    detailRows.push({ label: 'Cust AR Code', value: custArCode });
  }

  return (
    <>
      <GridContainer spacing={1} className={classes.independentRepContainer}>
        <GridItem
          xs={12}
          className={classes.independentRepTitle}
          spacing={2}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <InformationField value="Independent Rep : " variant="subtitle9" />
          {isRole && (
            <Button
              color="primary"
              size="small"
              onClick={() => setModalOpen(true)}
              className={classes.historyButton}
              sx={{ mr: 1 }}
            >
              History
            </Button>
          )}
        </GridItem>

        <GridItem className={classes.independentRepForm} xs={12}>
          <GridContainer spacing={1} sx={{ py: 0.5 }}>
            {detailRows.map((row) => (
              <GridItem xs={12} key={row.label} sx={{ px: 1 }}>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '130px 1fr',
                    columnGap: 1,
                    alignItems: 'start',
                  }}
                >
                  <InformationField value={`${row.label} :`} variant="subtitle9" sx={{ whiteSpace: 'nowrap' }} />
                  <InformationField
                    value={row.value}
                    variant="subtitle4"
                    sx={{ wordBreak: 'break-word', lineHeight: 1.35 }}
                  />
                </Box>
              </GridItem>
            ))}
          </GridContainer>
        </GridItem>
      </GridContainer>

      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onClose={closeModal}
          title={`Independent Rep pay for ${sublocation?.name}`}
          titleVariant="subtitle10"
          closeIcon={true}
          PaperProps={{
            sx: {
              width: '75%',
              maxWidth: 'none',

              maxHeight: '60%',
              height: '70%',
              overflow: 'hidden',
            },
          }}
        >
          <IndependantRepHistoryModal
            selectedSublocation={{
              sublocationId: sublocation?.id,
              name: sublocation?.name,
              independentRep: independentRep,
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default IndependentRepUserDetails;
